import _ from 'underscore';
import BaseModel from '@bingads-webui-campaign-legacy/bulk-operation/util/bulk-edit-job';

export default class ChangeLanguageModel extends BaseModel {

  initialize() {
    this.defaults = _.extend({}, BaseModel.prototype.defaults, {
      Entity: 'Campaign',
      BatchAction: {
        Actions: [{
          '@odata.type': '#Model.TextAction',
          'Property': 'Languages',
          'ActionType': 'Set',
          'Value': '',
          'SearchString': '',
          'Options': 'None',
        }],
      },
    });
  }
}
